import Input from "components/input/input.component";
import { IRedeemCode } from "interfaces/RegisterInterface";
import React from "react";
import { useNavigate } from "react-router";
import Button from "components/button/button";

const RedeemCode: React.FC<IRedeemCode> = ({
  handleRedeemCodeSubmit,
  redeemCode,
  handleSubmit,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="topic">
        <h2 className="text-display-lg text-white text-center">
          Let’s start learning
        </h2>
        <p className="mt-4 text-base font-normal leading-4 text-white text-center">
          If you have a code, enter it now!
        </p>
      </div>
      <div className="flex justify-center py-8">
        <div className="bg-white rounded-lg shadow-card w-full max-w-[360px] p-8 flex flex-col items-center gap-6">
          <img
            className="w-[72px] h-[72px]"
            src="/assets/icons/LoginCheck.svg"
            alt="Redeem Code"
            loading="lazy"
          />

          <div className="w-full">
            <Input
              id="code"
              name="code"
              label="Code"
              type="text"
              placeholder="ENTER CODE"
              value={redeemCode}
              onChange={(e) => {
                handleRedeemCodeSubmit(e.target.value);
              }}
            />
          </div>

          <Button
            type="submit"
            onClick={() => handleSubmit()}
            variant="primary"
            className="w-full"
          >
            Redeem Code
          </Button>
        </div>
      </div>
      <div className="flex justify-center mt-5">
        <p className="text-sm font-normal text-white">
          <span>Already have a subscription? </span>
          <span
            className="font-bold underline cursor-pointer text-white underline-offset-2"
            onClick={() => navigate("/login")}
          >
            Login
          </span>
        </p>
      </div>
    </>
  );
};

export default RedeemCode;
